export enum JobStatusEnum{
    INPROGRESS= "inprogress",
    COMPLETED = "completed",
    NOTVISITED= "notvisited"
}